// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre_wrapper[data-v-54442ab6]{display:flex;flex-direction:column;height:calc(75vh - 4.167vw)}.head[data-v-54442ab6]{height:1px}.content[data-v-54442ab6]{flex:1;overflow:auto}.foot[data-v-54442ab6]{height:3.125vw}", ""]);
// Exports
module.exports = exports;
